module.exports = __webpack_public_path__ + "static/img/a203.3a40c4d6.png";